module.exports = __webpack_public_path__ + "img/Rectangle 27.c484af1c.png";